import { BsInstagram } from "react-icons/bs";
import { FaTelegramPlane, FaTwitter } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io5";
import { SiLinkedin } from "react-icons/si";
import { Question } from "./FAQ";
import styled from "styled-components";
import { Accordion } from "react-rainbow-components";

const Footer = () => {
  return (
    <Container>
      <Layout>
        <div className="leftSlide">
          <Logo>
            <img src="/images/logo.png" alt="" />
            <h4>aliGasht.ir</h4>
          </Logo>
          <section>
            <p>
              تلفن پشتیبانی : 02101201548 <span>|</span> 021145394585
            </p>
            <p> دفتر پشتیبانی : تهران خیابان انقلاب روبروی بانک صادرات ایران</p>
          </section>

          <section>
            <img src="/images/enamad-b8f9b6ac.png" alt="" />
            <img src="/images/passenger-rights-dd64d114.svg" alt="" />
            <img src="/images/samandehi-6e2b448a.png" alt="" />
            <img src="/images/state-airline-f45c55b2.svg" alt="" />
            <img src="/images/ecunion-8b792f56.png" alt="" />
          </section>
        </div>

        <div className="rightSide">
          <List>
            <li>
              علی گشت
              <ul>
                <li>
                  {" "}
                  <a href="">درباره ما</a>
                </li>
                <li>
                  <a href="">تماس با ما </a>
                </li>
                <li>
                  {" "}
                  <a href="">چرا علی گشت؟</a>
                </li>
                <li>
                  {" "}
                  <a href="">وبلاگ علی گشت</a>
                </li>
              </ul>
            </li>
            <li>
              خدمات مشتریان
              <ul>
                <li>
                  {" "}
                  <a href="">مرکز پشتیبانی آنلاین</a>
                </li>
                <li>
                  {" "}
                  <a href="">مرکز خرید</a>
                </li>
                <li>
                  {" "}
                  <a href="">مرکز استرداد</a>
                </li>
                <li>
                  {" "}
                  <a href="">قوانین و مقررات</a>
                </li>
                <li>
                  {" "}
                  <a href=""> پرسش و پاسخ</a>
                </li>
              </ul>
            </li>
            <li>
              اطلاعات تکمیلی
              <ul>
                <li>
                  {" "}
                  <a href="">باشگاه مشتریان</a>
                </li>
                <li>
                  {" "}
                  <a href="">فروش سازمانی</a>
                </li>
                <li>
                  {" "}
                  <a href="">همکاری با آژانس ها</a>
                </li>
                <li>
                  {" "}
                  <a href="">فرصت های شغلی</a>
                </li>
              </ul>
            </li>
          </List>
        </div>

        <div className="mobile-version">
          <div className="rainbow-m-around_xx-large">
            <Accordion>
              <Question label="علی گشت">
                <ul>
                  <li>
                    {" "}
                    <a href="">درباره ما</a>
                  </li>
                  <li>
                    <a href="">تماس با ما </a>
                  </li>
                  <li>
                    {" "}
                    <a href="">چرا علی گشت؟</a>
                  </li>
                  <li>
                    {" "}
                    <a href="">وبلاگ علی گشت</a>
                  </li>
                </ul>
              </Question>
              <Question label="خدمات مشتریان">
                <ul>
                  <li>
                    {" "}
                    <a href="">مرکز پشتیبانی آنلاین</a>
                  </li>
                  <li>
                    {" "}
                    <a href="">مرکز خرید</a>
                  </li>
                  <li>
                    {" "}
                    <a href="">مرکز استرداد</a>
                  </li>
                  <li>
                    {" "}
                    <a href="">قوانین و مقررات</a>
                  </li>
                  <li>
                    {" "}
                    <a href=""> پرسش و پاسخ</a>
                  </li>
                </ul>
              </Question>
              <Question label="اطلاعات تکمیلی">
                <ul>
                  <li>
                    {" "}
                    <a href="">باشگاه مشتریان</a>
                  </li>
                  <li>
                    {" "}
                    <a href="">فروش سازمانی</a>
                  </li>
                  <li>
                    {" "}
                    <a href="">همکاری با آژانس ها</a>
                  </li>
                  <li>
                    {" "}
                    <a href="">فرصت های شغلی</a>
                  </li>
                </ul>
              </Question>
            </Accordion>
          </div>
        </div>
      </Layout>

      <div className="afterFooter" dir="auto">
        <p>
          کلیه حقوق این سرویس (وب‌سایت) محفوظ و متعلق به شرکت سفرهای علی گشت
          می‌باشد.
        </p>

        <ul>
          <li>
            <span>
              <FaTelegramPlane />
            </span>
          </li>
          <li>
            <span>
              <FaTwitter />
            </span>
          </li>
          <li>
            <span>
              <IoLogoYoutube />
            </span>
          </li>
          <li>
            <span>
              <SiLinkedin />
            </span>
          </li>
          <li>
            <span>
              <BsInstagram />
            </span>
          </li>
        </ul>
      </div>
    </Container>
  );
};

export default Footer;

const Container = styled.div`
  background-color: #ffff;
@media (max-width:900px){
  margin-bottom: 60px;
}

  .afterFooter {
    width: 1120px;
    margin: auto;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;

    @media (max-width: 1100px) {
      width: 98vw;
    }

    @media (max-width: 900px) {
      width: 100vw;
      flex-direction: column-reverse;

      p {
        padding: 0 5px;
        text-align: center;
      }
    }

    p {
      font-size: 13px;
      font-weight: 200;
      color: #8a8888;
    }

    ul {
      list-style: none;
      display: flex;

      @media (max-width: 900px) {
        margin: 0 auto;
      }

      li {
        margin: 0 20px;

        span {
          color: #8a8888;
          font-size: 24px;
        }
      }
    }
  }
`;

const Layout = styled.div`
  width: 1120px;
  margin: auto;
  display: flex;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);

  .mobile-version {
    display: none;
  }

  @media (max-width: 1120px) {
    width: 98vw;
  }

  @media (max-width: 900px) {
    width: 90vw;
    flex-direction: column-reverse;

    .mobile-version {
      display: block;
    }
  }

  .leftSlide {
    height: 300px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    @media (max-width: 900px) {
      height: 200px;
    }

    section {
      p {
        color: #616060;
        font-size: 15px;
        font-weight: 200;

        @media (max-width: 600px) {
          text-align: right;
          padding: 0 5px 0 0;
        }
        @media (min-width: 600px) and (max-width: 900px) {
          text-align: center;
          padding: 0 5px 0 0;
        }
      }

      img {
        width: 70px;
        height: 70px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 8px;
        margin: 0 5px;

        @media (max-width: 900px) {
          display: none;
        }
      }
    }
  }

  .rightSide {
    flex-grow: 1;
    height: 300px;

    @media (max-width: 900px) {
      display: none;
    }
  }
`;
const Logo = styled.div`
  img {
    width: 80px;
  }

  h4 {
    display: inline-block;
    font-size: 28px;
    font-style: italic;
    color: #e73511;
  }

  @media (max-width: 900px) {
    margin: 0 auto;
  }
`;

const List = styled.ul`
  padding-top: 40px;
  list-style: none;
  display: flex;
  justify-content: space-between;
  height: 100%;

  li {
    font-size: 17px;
    font-weight: 400;
    ul {
      list-style: none;
      li {
        margin: 10px 0;
        font-size: 15px;
        a {
          text-decoration: none;
          color: #616060;

          &:hover {
            color: #363636;
          }
        }
      }
    }
  }
`;
